import { useMutation, useQueryClient } from "@tanstack/react-query";
import { voidExpense } from "api/expense.api";
import {
  invalidateExpenseSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

export const useVoidExpense = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => voidExpense(id, { reason }),
    onSuccess: () => {
      invalidateExpenseSide(queryClient);
      invalidateVendorSide(queryClient);
    },
  });
};
